/* 🤖 this file was generated by svg-to-ts */
export const iconCloseToMe: {
    name: 'close_to_me';
    data: string;
} = {
    name: 'close_to_me',
    data: `<svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22"><path fill="#000" fill-rule="evenodd" d="m1.371 9.51-.092.05a.65.65 0 0 0 .126 1.15l7.136 2.75 2.75 7.135a.65.65 0 0 0 1.199.034l8.461-18.72a.65.65 0 0 0-.86-.86zm17.686-6.568-7.112 15.735-2.295-5.954-.047-.098a.65.65 0 0 0-.325-.275l-5.956-2.295z"/></svg>`
};
